import {
  Component,
  AfterViewChecked,
  AfterViewInit,
  OnInit,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import { FieldArrayType, FormGlobalService } from "@kre-form/core";
import {
  KreFormCommonService,
  KreFormTemplateOptions,
  KreFormFieldConfig,
} from "@kre-form/core";

import { KreFormAntService } from "../../tools/service";
@Component({
  selector: "kreform-overTime",
  templateUrl: "./index.html",
})
export class DeonFieldOverTime
  extends FieldArrayType
  implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  service: any;
  titles: KreFormTemplateOptions[] = [];
  showXScroll = true;
  screenTableWidth = window.screen.width - 162;
  tableWidth = 0;
  constructor(
    dyService: KreFormAntService,
    private globalService: FormGlobalService
  ) {
    super();
    this.service = dyService;
  }
  ngOnChanges() {}
  ngOnInit() {
    if (!!(this.field as any)["repeatRole"]) {
      // this.initProperty(
      //   (this.field as any)["repeatRole"],
      //   this.field.fieldGroup
      // );
    }

    if (!!this.field["show"]) {
      this.field.hide = !this.field["show"];
    }
    this.changeWidth();
    window.addEventListener("resize", this.chartresize, true);
  }

  initProperty(overTimeRole: any, fieldGroups: any) {
    Object.keys(overTimeRole).forEach((overtimeItemKey: string) => {
      let index: number = Number(
        overtimeItemKey.substr(overtimeItemKey.lastIndexOf("$") + 1)
      );
      if (!!fieldGroups) {
        fieldGroups.forEach((overtimes: any, ind: number) => {
          if (index === ind) {
            overtimes.fieldGroup.forEach((overtime: any) => {
              if (!!overTimeRole[overtimeItemKey][overtime.key]) {
                if (
                  (overtime.templateOptions === undefined ||
                    overtime.templateOptions === null) &&
                  overtime.type !== "repeat"
                ) {
                  overtime.templateOptions = {};
                }
                if (
                  overtime.editProperty === undefined ||
                  overtime.editProperty === null
                ) {
                  overtime.editProperty = {};
                }
                overtime.templateOptions = Object.assign(
                  overtime.templateOptions,
                  overTimeRole[overtimeItemKey][overtime.key].templateOptions
                );
                if (
                  overTimeRole[overtimeItemKey][overtime.key]["editor"] ===
                    false ||
                  overTimeRole[overtimeItemKey][overtime.key]["editor"] === true
                ) {
                  overtime.editor =
                    overTimeRole[overtimeItemKey][overtime.key]["editor"];
                }
                if (
                  overTimeRole[overtimeItemKey][overtime.key]["show"] ===
                    false ||
                  overTimeRole[overtimeItemKey][overtime.key]["show"] === true
                ) {
                  overtime.show =
                    overTimeRole[overtimeItemKey][overtime.key]["show"];
                }

                overtime.editProperty = Object.assign(
                  overtime.editProperty,
                  overTimeRole[overtimeItemKey][overtime.key].editProperty
                );
                if (overtime.type === "repeat") {
                  let repeatRole = overTimeRole[overtimeItemKey][overtime.key];
                  console.log(repeatRole);
                  let fieldGroups = (overtime as KreFormFieldConfig)
                    .fieldGroup as KreFormFieldConfig[];

                  this.initProperty(repeatRole, fieldGroups);
                }
              }
            });
          }
        });
      }
    });
  }

  ngOnDestroy() {
    window.removeEventListener("resize", this.chartresize, true);
  }
  ngAfterViewInit() {}
  fieldOperational(sign: string) {
    this.service.fieldOperational(sign, this.field);
  }

  groupOperational(type: string) {
    this.service.groupOperational(type, this.field);
  }

  delete(i: any) {
    if (this.field.fieldGroup && this.field.fieldGroup.length > 1) {
      this.remove(i);
    } else {
    }
  }

  chartresize = () => {
    this.changeWidth();
  };
  changeWidth() {
    let width = 300;
    if (
      this.field != undefined &&
      this.field != null &&
      this.field.fieldArray != undefined &&
      this.field.fieldArray != null &&
      this.field.fieldArray.fieldGroup != undefined &&
      this.field.fieldArray.fieldGroup != null
    ) {
      width = this.field.fieldArray.fieldGroup.length * 245 + 120;
    }

    this.tableWidth = width;
  }
  addIndex() {
    (this.field.fieldGroup as any[]).forEach((el: any, index: number) => {
      el.fieldGroup.forEach((ele: any) => {
        ele.templateOptions.index = index;
        if (
          this.field &&
          this.field.templateOptions &&
          (!!this.field.templateOptions.index ||
            this.field.templateOptions.index === 0)
        ) {
          ele.templateOptions.pIndex = this.field.templateOptions.index;
        }
      });
    });
  }
  isRemoved(f: KreFormFieldConfig): boolean {
    let result = true;
    if (this.editor === false) {
      result = false;
    }

    if (
      f!
        .fieldGroup!.filter(
          (el) => el.type !== "line" && el.type !== "htmlcontent"
        )!
        .every((el: any) => !!el!.editProperty && !!el!.editProperty!.delete)
    ) {
      result = false;
    }
    return result;
  }
  removed(i: number, isRemove: boolean) {
    if (!isRemove) {
      return;
    }
    this.remove(i);
    this.addIndex();
  }
  showErrors() {
    let that = this;
    return that.showError;
  }
  newRowId(i: number): string {
    return `${this.field.id}_${i}`;
  }
  newRepeatClass(): string {
    return `${this.field.id}_overTime`;
  }
}
